import IProduct from 'domains/products/models/IProduct'
import { AnyFormatType } from 'domains/formats/constants/formats'
import { getProductFormatPropByName } from 'domains/products/utils/products'

const isProductFormatExpired = (product: IProduct, format: AnyFormatType) =>
  getProductFormatPropByName(format, 'expired')(product) === true

export default isProductFormatExpired
